/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
// --- Autoplay for all Broadcast sliders that use Swiper.js ---
document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll('.swiper');

  sliders.forEach(slider => {
    if (slider.swiper) {
      slider.swiper.params.autoplay = {
        delay: 3000,  // tempo entre slides (3s)
        disableOnInteraction: false
      };
      slider.swiper.autoplay.start();
    }
  });
});
